import BCVRateHistory from "@/components/rates/BCVRateHistory";
import { useLanguage } from "@/contexts/LanguageContext";

/**
 * The official BCV rate, day by day.
 *
 * Platform-level rather than per-building: there is one national rate, and
 * every HOA bills against the same number. The super admin view is the same
 * table the HOA admins see — the difference is that this is where you come
 * to check the scraper is still running, which is what the coverage tiles
 * and the gap warning are for.
 */
export default function RatesPage() {
  const { t } = useLanguage();

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-[19px] font-semibold tracking-[-0.01em] text-gray-900 sm:text-[21px]">
          {t("rates.title")}
        </h1>
        <p className="mt-0.5 text-[13px] text-gray-500">{t("rates.subtitle")}</p>
      </header>

      <BCVRateHistory />
    </div>
  );
}
